import { render, staticRenderFns } from "./memberTradeCoinRecord.vue?vue&type=template&id=2f1e46d5&scoped=true"
import script from "./memberTradeCoinRecord.vue?vue&type=script&lang=js"
export * from "./memberTradeCoinRecord.vue?vue&type=script&lang=js"
import style0 from "./memberTradeCoinRecord.vue?vue&type=style&index=0&id=2f1e46d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e46d5",
  null
  
)

export default component.exports